import { Button, Stack, Title } from "@mantine/core";
import { IconArrowsSplit, IconBox, IconBrain, IconMoneybag } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { NewBadge } from "@/components/common/ui/badge/NewBadge";
import { userStore } from "@/mobx/rootStore";
import { routesList } from "@/routesList";
import { useAppSizeId } from "@/utils/hooks/useAppSizeId";

const APPS = [
	{
		label: "Mementos",
		icon: <IconBrain />,
		appName: "mementos",
		route: routesList.mementos.path,
	},
	{
		label: "Items",
		icon: <IconBox />,
		appName: "items",
		route: routesList.items.path,
	},
	{
		label: "Economos",
		icon: <IconMoneybag />,
		appName: "economos",
		route: routesList.economos.path,
	},
	{
		label: "Split",
		icon: <IconArrowsSplit />,
		appName: "split",
		route: routesList.split.path,
		isNew: true,
	},
];

/**
 * @param {object} props
 * @param {() => void} [props.closeMobileFnc]
 * @param {boolean} [props.withTitle=true]
 */
export default function AppSelector({ closeMobileFnc = () => {}, withTitle = true }) {
	const location = useLocation();
	const navigate = useNavigate();

	const { isMobile } = useAppSizeId();

	const currentApp = (location.pathname ?? "").split("/")[1]; // "/mementos/asd" -> "mementos"

	const onAppClick = (app) => {
		userStore.lastApp = app.appName;

		navigate(app.route);

		if (isMobile) {
			closeMobileFnc();
		}
	};

	return (
		<Stack gap="sm">
			{withTitle && <Title order={4}>Aplicaciones</Title>}

			{APPS.map((_app) => {
				const isCurrentApp = _app.appName === currentApp;
				const isExactPath = location.pathname === _app.route;

				return (
					<Button
						key={_app.appName}
						variant={isCurrentApp ? "light" : "subtle"}
						onClick={isExactPath ? undefined : () => onAppClick(_app)}
						leftSection={_app.icon}
						rightSection={_app.isNew && <NewBadge ml="xxs" />}
					>
						{_app.label}
					</Button>
				);
			})}
		</Stack>
	);
}
